/**
 * Internal dependencies
 */
import { createSlotFill } from '../slot-fill';

const { Fill, Slot } = createSlotFill( '__unstableAutocompletionItemsSlot' );

export {
	Fill as __unstableAutocompletionItemsFill,
	Slot as __unstableAutocompletionItemsSlot,
};
